import { createAction } from 'redux-actions';

export const TYPES = {
  ACTIVE_TAB_CHANGED: 'ACTIVE_TAB_CHANGED',
};

export function createActiveTabChangedAction(activeTab) {
  return createAction(TYPES.ACTIVE_TAB_CHANGED)(activeTab);
}
